import React from 'react';
import {Props} from './model';
import {Platform, View} from 'react-native';
import {Button} from '../../../../shared/components/button';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {images} from '../../../../assets/icons';
import {Text} from '../../../../shared/components/text';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {useIsSmallScreenDevice} from '../../../../shared/hooks/useIsSmallScreenDevice';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../../../redux/selectors/runtime/theme';
import {VisImpStatus} from '../../../../shared/models/visuallyImpairedSettings';
import {AllowedPlatform, ExternalAppController, ExternalAppName} from '../../../../shared/constants/externalApps';

export default ({content}: Props) => {
  const isSmallDevice = useIsSmallScreenDevice();
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: mediaOnly(DeviceSize.desktop, {width: 820, maxWidth: '90%'}),
    upperPart: mediaOnly(DeviceSize.desktop, {
      flexDirection: 'row',
    }),
    textWrapper: mediaOnly(DeviceSize.desktop, {
      flex: 7,
      marginRight: 5,
    }),
    buttonsSection: {
      ...mediaOnly(DeviceSize.desktop, {
        flex: 6,
        alignContent: 'flex-start',
        flexDirection: 'column',
        borderLeftColor: theme.color.borderColor,
        borderLeftWidth: 1,
        borderStyle: 'solid',
      }),
    },
    buttonWrapper: {
      ...mediaOnly(DeviceSize.desktop, {
        flexBasis: 227,
      }),
    },
    buttonPictureSubSection: {
      flexDirection: 'row',
      alignItems: 'center',

      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginBottom: 14,
          marginLeft: 30,
        },
        {
          justifyContent: 'flex-start',
          marginVertical: Platform.OS === 'web' ? 8 : 0,
        },
      ),
    },
    text: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.bodySmallLight},
        {
          ...theme.fonts.bodySmallLight,
        },
      ),
      color: theme.color.textColor,
    },
    link: {
      color: theme.color.linkColor,
    },
    button: {
      margin: 0,
      ...mediaOnly(DeviceSize.mobile, {width: Platform.OS === 'web' ? 250 : '100%'}),
      ...mediaOnly(DeviceSize.tablet, {width: 328}),
    },
    featuresTitleWrapper: mediaOnly(DeviceSize.desktop, {
      marginTop: 40,
      ...theme.fonts.h5,
    }),
    cardInfoWrapper: mediaOnly(
      DeviceSize.desktop,
      {
        marginBottom: 50,
      },
      {
        marginBottom: 20,
      },
    ),
    cardReplenishmentWrapper: mediaOnly(DeviceSize.mobile, {marginBottom: 30}),
    featuresTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.action,
        },
        {
          ...theme.fonts.bodySmallLight,
        },
      ),
      color: theme.color.textColor,
    },
    hintTitle: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.textColor,
    },
    picWrapper: mediaOnly(
      DeviceSize.desktop,
      {alignContent: 'center', alignSelf: 'center'},
      {marginLeft: isSmallDevice ? 30 : 40},
    ),
  }));
  const {Ekarta, EkartaBlack, Frisbi, FrisbiBlack} = images;
  const isDesktop = useIsDesktop();
  const themeSettings = useSelector(themeSelector());
  const visuallyImpairedActive = themeSettings.visuallyImpaired === VisImpStatus.Active;
  const EkartaIcon = visuallyImpairedActive ? EkartaBlack : Ekarta;
  const FrisbiIcon = visuallyImpairedActive ? FrisbiBlack : Frisbi;

  const openReplenishment = (appName: ExternalAppName) => {
    const appDetail = ExternalAppController[appName][Platform.OS as AllowedPlatform];
    if (appDetail.openLink) {
      appDetail.openLink();
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.upperPart}>
        <View style={styles.textWrapper}>
          <Text style={styles.hintTitle}>Пополнить карту можно любым из данных способов:</Text>
        </View>

        <View style={styles.buttonsSection}>
          <View style={styles.buttonPictureSubSection}>
            <View style={styles.buttonWrapper}>
              <Button
                id='replenishment-charge-ecard'
                onPress={() => openReplenishment('Ekarta')}
                block={true}
                style={styles.button}
                type='primary'
                text='Пополнить'
              />
            </View>
            <View style={[styles.picWrapper, {marginLeft: 30}]}>
              <EkartaIcon width={97} height={28} />
            </View>
          </View>

          <View style={[styles.buttonPictureSubSection, {marginBottom: isSmallDevice ? 10 : 15}]}>
            <View style={styles.buttonWrapper}>
              <Button
                id='replenishment-charge-frisbi'
                onPress={() => openReplenishment('Frisbi')}
                block={true}
                style={styles.button}
                type='secondary'
                text='Пополнить'
              />
            </View>
            <View style={[styles.picWrapper, {marginLeft: 50}]}>
              <FrisbiIcon width={isSmallDevice ? 44 : 52} height={isSmallDevice ? 44 : 52} />
            </View>
          </View>
        </View>
      </View>
      <View style={styles.featuresTitleWrapper}>
        <Text testID='nonfinancial-transport-card-description-id' style={styles.featuresTitle}>
          {isDesktop
            ? content.services.transportService.nonFinancial.descriptionDesktop
            : 'С информацией о транспортном приложении вы можете ознакомиться в разделе “Поддержка”'}
        </Text>
      </View>
    </View>
  );
};
